<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="h1" id="d7e1944156" style="color: #82a339"><b>VEGETABLE CHOWDER</b></p>
<p class="ext" id="d7e1944656"><b><i>If you have your own vegetable garden or if you live near a farmers’ market, you will want to make this luscious soup to take advantage of the fresh summer produce.</i></b></p>
<p class="h4" id="d7e1946356" style="color: #496210"><b>Prep: 15 minutes Cook: 30 minutes</b></p>
<p class="ul" id="d7e1946856">2 tablespoons olive oil</p>
<p class="ul" id="d7e1947156">1 large onion (12 ounces), chopped</p>
<p class="ul" id="d7e1947456">3 cups water</p>
<p class="ul" id="d7e1948056">3 medium zucchini and/or yellow summer squashes <br/> (about 8 ounces each), coarsely chopped</p>
<p class="ul" id="d7e1948656">2 red and/or yellow peppers, coarsely chopped</p>
<p class="ul" id="d7e1949056">3 large ripe tomatoes (2 pounds), coarsely chopped</p>
<p class="ul" id="d7e1949356">3 large garlic cloves, crushed with garlic press</p>
<p class="ul" id="d7e1949656">½ teaspoon fennel seeds</p>
<p class="ul" id="d7e1950556">2 teaspoons salt</p>
<p class="ul" id="d7e1950956">¼ teaspoon ground black pepper <br/> sliced fresh basil leaves for garnish</p>
<p class="pub" id="d7e1952356" style="margin-top: 1.5em;"><span style="color: #c15b49"><b>1.</b></span> In 5-quart saucepot or Dutch oven, heat oil over medium-high heat. Add onion and cook until tender and lightly browned, about 10 minutes. Add water, zucchini and/or yellow squashes, peppers, tomatoes, garlic, fennel seeds, salt, and black pepper; heat to boiling. Reduce heat to medium and cook, uncovered, until vegetables are tender, about 20 minutes.</p>
<p class="pub" id="d7e1955456"><span style="color: #c15b49"><b>2.</b></span> Spoon one-third of the mixture into blender; cover, with center part of cover removed to let steam escape, and puree until smooth. Pour puree into bowl. Repeat with remaining mixture.</p>
<p class="pub" id="d7e1957356"><span style="color: #c15b49"><b>3.</b></span> To serve hot, return soup to same clean saucepot and heat through. To serve cold, cover and refrigerate at least 4 hours. Garnish with sliced basil. Makes about 9 cups or 6 main-dish servings.</p>
<p class="ntx" id="d7e1959556">Each serving: About 120 calories, 4g protein, 18g carbohydrate, 5g total fat (1g saturated), 0mg cholesterol, 795mg sodium.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// West_9781618371621_epub_c54_r1.vue?21a0ceb4